import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var OpportunitiesApiService = /*#__PURE__*/function () {
  function OpportunitiesApiService() {
    _classCallCheck(this, OpportunitiesApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(OpportunitiesApiService, [{
    key: "GetOpportunities",
    value: function GetOpportunities(formData) {
      var url = "".concat(this._appRoot, "/Api/OpportunitiesApi/GetOpportunities");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetOpportunityDetail",
    value: function GetOpportunityDetail(id) {
      var url = "".concat(this._appRoot, "/Api/OpportunitiesApi/GetOpportunity/").concat(id);
      return Ajax.Get(url);
    }
  }, {
    key: "RespondToOpportunity",
    value: function RespondToOpportunity(formData) {
      var url = "".concat(this._appRoot, "/Api/OpportunitiesApi/Respond");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetConfigurations",
    value: function GetConfigurations() {
      var url = "".concat(this._appRoot, "/Api/OpportunitiesApi/GetConfigurations");
      return Ajax.Get(url);
    }
  }, {
    key: "HasResponded",
    value: function HasResponded(opportunityId, contactId) {
      var url = "".concat(this._appRoot, "/Api/OpportunitiesApi/HasResponded?opportunityId=").concat(opportunityId).concat(!!contactId ? "&contactId=".concat(contactId) : '');
      return Ajax.Get(url);
    }
  }]);

  return OpportunitiesApiService;
}();